import Rosa from "../assets/Rosa.png";
import Nai from "../assets/Nai.png";
import Rach from "../assets/Rach.png";
import Team from "../components/Team";

export default function About() {
  return (
    <>
      <div class="relative py-16 bg-gray-100 overflow-hidden">
        <div class="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full">
          <div
            class="relative h-full text-lg max-w-prose mx-auto"
            aria-hidden="true"
          >
            <svg
              class="absolute top-12 left-full transform translate-x-32"
              width="404"
              height="384"
              fill="none"
              viewBox="0 0 404 384"
            >
              <defs>
                <pattern
                  id="74b3fd99-0a6f-4271-bef2-e80eeafdf357"
                  x="0"
                  y="0"
                  width="20"
                  height="20"
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x="0"
                    y="0"
                    width="4"
                    height="4"
                    class="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width="404"
                height="384"
                fill="url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)"
              />
            </svg>
            <svg
              class="absolute top-1/2 right-full transform -translate-y-1/2 -translate-x-32"
              width="404"
              height="384"
              fill="none"
              viewBox="0 0 404 384"
            >
              <defs>
                <pattern
                  id="f210dbf6-a58d-4871-961e-36d5016a0f49"
                  x="0"
                  y="0"
                  width="20"
                  height="20"
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x="0"
                    y="0"
                    width="4"
                    height="4"
                    class="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width="404"
                height="384"
                fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)"
              />
            </svg>
            <svg
              class="absolute bottom-12 left-full transform translate-x-32"
              width="404"
              height="384"
              fill="none"
              viewBox="0 0 404 384"
            >
              <defs>
                <pattern
                  id="d3eb07ae-5182-43e6-857d-35c643af9034"
                  x="0"
                  y="0"
                  width="20"
                  height="20"
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x="0"
                    y="0"
                    width="4"
                    height="4"
                    class="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width="404"
                height="384"
                fill="url(#d3eb07ae-5182-43e6-857d-35c643af9034)"
              />
            </svg>
          </div>
        </div>
        <div class="relative px-4 sm:px-6 lg:px-8">
          <div class="text-lg max-w-prose mx-auto">
            <h1 className="text-center">
              <span class="block text-base  text-violet-600 font-semibold tracking-wide uppercase">
                Nuestra Historia
              </span>

              <span class="mt-2 block text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                ¿Por qué nace Cryptonikas Dao?
              </span>
            </h1>
          </div>
          <div class="mt-6 text-left prose prose-violet prose-lg text-gray-500 mx-auto">
            <p className="text-justify">
              Al notar la ausencia de mujeres y no binaries en la comunidad
              Web3, decidimos unir nuestros conocimientos y experiencias y crear
              un equipo que incentive y brinde el apoyo necesario en este tema.
              La idea ha sido siempre invitar y educar a la comunidad de
              hispanohablantes a evolucionar con las nuevas tecnologías y a
              invertir en su futuro e incluso en su crecimiento profesional.
            </p>

            <h3 className="text-violet-600">Misión</h3>
            <blockquote>
              <p>
                Informar, educar y asesorar a las mujeres y no binarios
                hispanohablantes sobre Web3
              </p>
            </blockquote>

            <p className="text-justify">
              Nuestra misión es compartir conocimientos, experiencias personales
              y lo aprendido en el camino, a través de espacios, charlas y
              contenido en digital en materia de NTFs, Crypto y Web3 a la
              comunidad hispanohablante. De igual manera, queremos servir como
              agentes de guía y asesoría en la creación y desarrollo de
              proyectos de Web3 para los que desean incursar en esta nueva
              tecnología. 
            </p>

            <h3 className="text-violet-600">Visión</h3>
            <blockquote>
              <p>
                Consolidarnos como una comunidad educativa, generadora de
                espacios de aprendizajes significativos e innovadores para
                lograr que las mujeres hispanohablantes y no binarios obtengan y
                ocupen más posiciones importantes y/o de liderazgos en la Web3
              </p>
            </blockquote>
          </div>
        </div>
      </div>

      <div class="bg-gradient-to-r from-purple-800 to-indigo-700">
        <div class="max-w-7xl mx-auto py-12 px-4 text-center sm:px-6 lg:px-8 lg:py-24">
          <div class="space-y-12">
            <Team />
          </div>
        </div>
      </div>
    </>
  );
}
